import { render } from "./PlaceDetailPage.vue?vue&type=template&id=3e770064&scoped=true&ts=true"
import script from "./PlaceDetailPage.vue?vue&type=script&lang=ts"
export * from "./PlaceDetailPage.vue?vue&type=script&lang=ts"

import "./PlaceDetailPage.vue?vue&type=style&index=0&id=3e770064&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e770064"]])

export default __exports__